import { useLogoutFunction } from '@propelauth/react';
import { Mail } from 'lucide-react';

import { useAppDispatch } from '@/app/store/utils/redux.hooks';
import { performFullLogout } from '@/features/authentication/utils/auth-utils';

import { Button } from '../ui/button';

interface EmailVerificationRequiredMessageProps {
  email: string;
}

export function EmailVerificationRequiredMessage({ email }: EmailVerificationRequiredMessageProps) {
  const dispatch = useAppDispatch();
  const propelAuthLogout = useLogoutFunction();
  // const handleResendVerification = () => {
  //   // TODO: Implement resend verification email logic if your auth provider supports it
  //   console.log('Resend verification email to:', email);
  //   alert('Resend functionality is not yet implemented. Check console.');
  // };

  const handleBackToLogin = async () => {
    // window.location.href = '/auth/login';
    try {
      await performFullLogout(dispatch, propelAuthLogout);
      // You might want to navigate the user to the login page or homepage after logout
      // For example: window.location.href = '/auth/login';
    } catch (error) {
      console.error('Logout failed:', error);
      // Handle logout error, maybe show a notification to the user
    }
  };

  return (
    <div className="space-y-6 text-center">
      {/* <p className="text-sm text-neutral-800">We sent you an email to {email} .</p> */}

      <div className="pt-4 space-y-3">
        {/* <button
          onClick={handleResendVerification}
          className="w-full font-medium text-white transition-all duration-300 bg-black rounded-lg h-11 hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
        >
          Resend Verification Email
        </button> */}
        <Button onClick={handleBackToLogin} variant="default">
          Back to Login
        </Button>
      </div>
    </div>
  );
}
